/**
 * DevExtreme (esm/common/core/events/double_click.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { name, dblClick } from "../../../__internal/events/m_dblclick";
import registerEvent from "./core/event_registrator";
registerEvent(name, dblClick);
export { name };